<template>
	<div class="traveler">
		<back-to></back-to>
		<!-- 提交表单 -->
		<section class="travelerForm">
			<div class="title">添加常用联系人</div>
			<div class="travelerForm-van">
				<section v-for="(item, index) in listArray" :key="index" class="travelerForm-vans">
					<!-- 选择器 -->
					<van-field v-if="item.TagAttribute == 'select'" readonly clickable name="picker"
						v-model="item.TagValue" :label="item.TagName" :required="item.IsMust"
						:placeholder="'请选择'+item.TagName" :rules="[{ required: item.IsMust?true:false}]"
						@click="showPicker = true,columns = item.SelectValue,selectIndex=index" />
					<van-popup v-model="showPicker" position="bottom">
						<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
					</van-popup>

					<!-- 文本框 -->
					<van-field v-if="item.TagAttribute != 'select'" v-model="item.TagValue" :required="item.IsMust"
						:label="item.TagName" :placeholder="'请填写'+item.TagName"
						:rules="[{ required: item.IsMust?true:false}]" @input="inputBtn(index,item.TagValue)" />
				</section>

			</div>
		</section>
		<div class="travelerForm-b" @click="onSubmit">
			保存
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import {
		validatePhoneNumber,
		formatTime
	} from '@/config/util'
	import BackTo from "@/components/BackTo";
	import {
		Dialog
	} from 'vant'
	export default {
		name: 'traveler',
		components: {
			BackTo
		},
		data() {
			return {
				listArray: [],
				name: '',
				obj: '',
				columns: [],
				showPicker: false,
				selectIndex: "",
				travellerID: '-1'
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		created() {
			this.obj = this.$route.query.object ? JSON.parse(this.$route.query.object) : ""
			this.travellerID = this.$route.query.object ? this.obj.TravellerID : '-1'
			console.log(this.obj)
		},
		mounted() {
			this.getList()
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f7f7f7')
		},
		methods: {
			onConfirm(value) {
				let data = this.listArray
				data[this.selectIndex].TagValue = value
				this.listArray = data
				this.showPicker = false;
			},
			onSubmit() {
				var arr = []
				let list = this.listArray
				for (let i = 0; i < list.length; i++) {
					if (list[i].IsMust == true && list[i].TagValue == '') {
						Dialog.alert({
							message: '请填写' + list[i].TagName
						})
						return
					}
					const obj = {}
					obj.TravellerTemplateTagID = list[i].TravellerTemplateTagID
					obj.TagValue = list[i].TagValue.toString().replace(/\s+/g, "");
					arr.push(obj)
				}
				this.$post(
					this.$dbqnr + '/NewOrder/AddContact', {
						"WebUserID": this.userInfo.userId, //用户ID
						"TravellerList": [{
							'ID': this.travellerID,
							'Info': arr
						}]
					}
				).then(res => {
					if (res.IsSuccess) {
						Dialog.alert({
							message: '保存成功',
						}).then(() => {
							this.$router.back(-1)
						});

					} else {
						Dialog.alert({
							message: res.ErrorMsg
						})
					}
				})
			},
			inputBtn(e, value) {
				let data = this.listArray
				data[e].TagValue = value
				this.listArray = data
			},
			getList() {
				this.$post(
					this.$apiWebsiteSweet + '/NewOrder/GetContactTemp', {}
				).then(res => {
					res.TravellerInfos.forEach((e, index) => {
						if (this.obj != '') {
							e.TagValue = this.obj.TravellerInfos[index].TagValue
						}
						if (e.TagAttribute == "select") {
							e.SelectValue = e.SelectValue.split(",")
						}

					});
					this.listArray = res.TravellerInfos
				})
			},

		}
	}
</script>

<style scoped>
	.travelerForm {
		width: 100%;
		/* padding: 20px 30px;
		box-sizing: border-box; */
	}

	.title {
		font-size: 26px;
		color: #999999;
		padding: 20px;
		box-sizing: border-box;
		width: 100%;
	}

	.travelerForm-van {
		/* border-radius: 25px; */
		padding: 10px;
		box-sizing: border-box;
		width: 100%;
		background-color: #fff;
	}

	.travelerForm-vans {
		border-bottom: 1px solid #f7f7f7;
	}

	.travelerForm-vans:last-child {
		border: 0;
	}

	.travelerForm-b {
		width: 710px;
		margin: 40px auto;
		height: 90px;
		line-height: 90px;
		text-align: center;
		background: #F9902F;
		box-shadow: 0px 3px 10px 1px rgba(236, 224, 215, 0.6784);
		font-size: 36px;
		color: #fff;
		border-radius: 40px;
	}

	.travelerForm-van .van-overlay {
		background-color: rgba(0, 0, 0, .1);
	}
</style>
